@for (item of (staticElementList | concatArray: dynamicElementList) ; track item; let index = $index){
  @switch (mode){
    @case (ModeEnum.OPTIONS){
      <mat-option [value]="item.label" (click)="onClick(item)" (ngxVisibility)="checkVisible($event, index)">
        <div class="flex align-item-center option-item text-black-500">
          @if (item.image) {
            <div class="flex-shrink-0 m-r-10">
              <img class="option-image" [src]="item.image" alt="{{item.label}}" />
            </div>
          }

          <div class="flex-grow-1 p-2" >
            {{ item.label }}

            @for (badge of item.badges; track badge) {
              <span class="badge m-l-5">{{ badge }}</span>
            }
          </div>
        </div>
      </mat-option>
    }
    @default {
      <app-card [showHeader]="false" (ngxVisibility)="checkVisible($event, index)">
        <span class="f-w-600">{{ item.label }}</span>
        <p>{{ item.description }}</p>
        @for (badge of item.badges; track badge) {
          <mat-chip>{{badge}}</mat-chip>
        }
      </app-card>
    }
  }
}
